import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { Row, Col, ContainerFluid } from '@navent-jobs/ui-kit/components/grid'
import { Checkbox } from '@navent-jobs/ui-kit/components/checkbox'

// mixins
import {
  ModalComponent,
  ModalBodyComponent,
  ModalBodyContent,
  ModalFooterComponent,
  CardContainer,
  CustomLink,
  CustomDiv,
  ContainerCheck,
  ModalLegalesContent,
} from './mixins'

import Card from '../../card'
import AdvertenciaLegales from '../advertencia-legales'
import { DataLayersPostPostulacion } from '../../../constants/gtm-events-post-postulacion'
import { showSnackbar, showSnackbarError } from '../../../redux/actions/applicant/curriculum/snackbar'
import { editSuscriptionAction } from '../../../redux/actions/suscriptcion'

const NOTIFICATION_BTS_ID = 2
const CONFIDENCIAL = 'Confidencial'

interface ModalAvisosProps {
  id: string
  width: number
  visible: boolean
  closeModal: Function
  avisos?: any
  title: string | React.ReactElement
  subtitle: string
  primaryButtonAction: string
  primaryButtonText: string
  secondaryButtonAction?: Function
  secondaryButtonText?: string
  onClickAviso?: Function
  withSubscriptionCheck?: boolean
  desuscripto: any
  notificationSettingsStore: any
  labsParams?: string
}

const ModalFooter = ({
  primaryButtonAction,
  primaryButtonText,
  secondaryButtonAction,
  secondaryButtonText,
  withSubscriptionCheck,
  desuscripto,
  notificationSettingsStore,
}) => {
  const dispatch = useDispatch()
  const [subscriptionCheck, setSubscriptionCheck] = useState(true)

  const secondaryButtonHandler = () => {
    DataLayersPostPostulacion.relacionadosClick('Volver al aviso')
    secondaryButtonAction()
  }

  const primaryButtonHandler = () => {
    DataLayersPostPostulacion.relacionadosClick('Ver más avisos')
  }

  // Solo para sincronizar sistema viejo con el nuevo de suscripciones.
  // TODO unificar sistemas y borrar

  useEffect(() => {
    if (withSubscriptionCheck && !desuscripto) {
      dispatch(editSuscriptionAction({ email: true, idCategoria: 2, push: null }))
    }
  }, [withSubscriptionCheck, desuscripto])

  useEffect(() => {
    if (notificationSettingsStore.setStates.success) {
      dispatch(showSnackbar('Guardamos tus cambios', 'icon-light-save'))
    }
    if (notificationSettingsStore.setStates.error) {
      dispatch(showSnackbarError('Ocurrió un error inesperado.'))
      setSubscriptionCheck(!subscriptionCheck)
    }
  }, [notificationSettingsStore.setStates.success, notificationSettingsStore.setStates.error])

  return (
    <ModalFooterComponent>
      <ContainerFluid>
        <Row>
          <Col xs={{ size: 12, order: 2 }} sm={{ size: 6, order: 1 }}>
            {secondaryButtonText && secondaryButtonAction && (
              <CustomDiv>
                <CustomLink
                  linkoptions={{ variant: 'primary', type: 'link', size: 'medium', block: true }}
                  onClick={secondaryButtonHandler}
                >
                  {secondaryButtonText}
                </CustomLink>
              </CustomDiv>
            )}
          </Col>

          <Col xs={{ size: 12, order: 1 }} sm={{ size: 6, order: 2 }}>
            <div onClick={primaryButtonHandler}>
              <CustomLink
                linkoptions={{ variant: 'primary', type: 'fill', size: 'medium', block: true }}
                href={primaryButtonAction}
              >
                {primaryButtonText}
              </CustomLink>
            </div>
          </Col>
        </Row>
      </ContainerFluid>
      {withSubscriptionCheck && !desuscripto && (
        <ContainerCheck>
          <Checkbox
            id="check-id"
            name="check-subscription"
            label="Acepto el envío de recomendaciones inteligentes de empleos a mi correo electrónico"
            fieldOptions={{
              size: 'small',
              variant: 'lighten',
            }}
            checked={subscriptionCheck}
            onChange={() => {
              setSubscriptionCheck(!subscriptionCheck)
              dispatch(
                editSuscriptionAction({ email: !subscriptionCheck, idCategoria: NOTIFICATION_BTS_ID, push: null })
              )
            }}
          />
        </ContainerCheck>
      )}
    </ModalFooterComponent>
  )
}

const ModalAvisos = ({
  primaryButtonAction,
  primaryButtonText,
  secondaryButtonAction,
  secondaryButtonText,
  width,
  visible,
  closeModal,
  avisos,
  title,
  subtitle,
  onClickAviso,
  withSubscriptionCheck = false,
  desuscripto,
  notificationSettingsStore,
  labsParams = '',
}: ModalAvisosProps) => {
  const closeModalHandler = () => {
    DataLayersPostPostulacion.relacionadosClick('Cerrar')
    closeModal()
  }

  const clickAvisoHandler = (event, aviso) => {
    DataLayersPostPostulacion.relacionadosClick('Click aviso')
    onClickAviso && onClickAviso(event, aviso)
  }

  useEffect(() => {
    if (visible) {
      DataLayersPostPostulacion.relacionadosImpresion()
    }
  }, [visible])

  return (
    <ModalComponent
      skin="with-info"
      width={width}
      visible={visible}
      onClose={closeModalHandler}
      title={title}
      subtitle={subtitle}
      footer={
        <ModalFooter
          primaryButtonAction={primaryButtonAction}
          primaryButtonText={primaryButtonText}
          secondaryButtonAction={secondaryButtonAction}
          secondaryButtonText={secondaryButtonText}
          withSubscriptionCheck={withSubscriptionCheck}
          desuscripto={desuscripto}
          notificationSettingsStore={notificationSettingsStore}
        />
      }
    >
      <ModalBodyComponent>
        <ContainerFluid>
          <Row>
            <Col noGutter>
              <ModalBodyContent>
                {avisos &&
                  avisos.map((aviso, index) => {
                    return (
                      <CardContainer key={aviso}>
                        <Card
                          disableLink={false}
                          aviso={aviso}
                          index={index}
                          onClick={({ event }) => clickAvisoHandler(event, aviso)}
                          ubicacion="Modal - Aviso finalizado - Sugeridos"
                          link={`${makeFichaAvisoURL({
                            ...aviso,
                            empresa: {
                              denominacion: aviso.empresa,
                              confidencial: aviso.empresa === CONFIDENCIAL,
                            },
                          })}${labsParams}`}
                        />
                      </CardContainer>
                    )
                  })}
              </ModalBodyContent>
            </Col>
          </Row>
          <Row>
            <Col sm={8} offset={{ sm: 2 }}>
              <ModalLegalesContent>
                <AdvertenciaLegales small semibold />
              </ModalLegalesContent>
            </Col>
          </Row>
        </ContainerFluid>
      </ModalBodyComponent>
    </ModalComponent>
  )
}

export default ModalAvisos
